import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, ToggleButton, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import IconCheckbox from "../../components/Form/IconCheckbox";
import FolderLookup from "../../components/Form/FolderLookup";
import DriverSubform from "../../components/Form/DriverSubform";
import Client from "../../helpers/ApiClient";
import immutable from "immutable";
import {ModalWindow} from 'reactis-modal';
import DriverList from '../../containers/Driver/PickerList';
import TrainingList from '../../containers/Training/PickerList';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'document.fetch',
			save: 'document.save',
			remove: 'document.delete'
		};

		this.changeEvent = 'document.change';

		this.messages = {
			remove: 'Opravdu si přejete dokument odstranit?',
			notfound: 'Dokument nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			folder: {
				class: FolderLookup,
				label: 'Složka'
			},
			/*published: {
				class: IconCheckbox,
				label: 'Publikovat',
				value: 0
			},*/
			type: {
				class: RadioList,
				label: 'Typ',
				options: DbInfo.DocumentType,
				value: 1
			},
			yt_video: {
				class: TextInput,
				label: 'Video',
				visible: (row) => {
					return row.type == 2
				}
			},
			files: {
				class: FileUpload,
				label: 'Soubory',
				visible: (row) => {
					return row.type == 1 || row.type == 3
				}
			},
			op_a: {
				class: ToggleButton,
				title: 'A',
			},
			op_b: {
				class: ToggleButton,
				title: 'B',
			},
			op_c: {
				class: ToggleButton,
				title: 'C',
			},
			op_d: {
				class: ToggleButton,
				title: 'D',
			},
			op_e: {
				class: ToggleButton,
				title: 'E',
			},
			op_f: {
				class: ToggleButton,
				title: 'F',
			},
			op_g: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m: {
				class: ToggleButton,
				title: 'M',
			},
			op_z: {
				class: ToggleButton,
				title: 'Z',
			},

			op_a_2: {
				class: ToggleButton,
				title: 'A',
			},
			op_b_2: {
				class: ToggleButton,
				title: 'B',
			},
			op_c_2: {
				class: ToggleButton,
				title: 'C',
			},
			op_d_2: {
				class: ToggleButton,
				title: 'D',
			},
			op_e_2: {
				class: ToggleButton,
				title: 'E',
			},
			op_f_2: {
				class: ToggleButton,
				title: 'F',
			},
			op_g_2: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1_2: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2_2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m_2: {
				class: ToggleButton,
				title: 'M',
			},
			op_z_2: {
				class: ToggleButton,
				title: 'Z',
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	pickDriver(type = 1) {
		this.popupDriver = new ModalWindow(null, <DriverList onAdd={(text) => this.handleAddDriver(text, type)} />);
		this.popupDriver.className = 'wide950';
		this.popupDriver.show(this.context.store.dispatch);
	}

	pickTraining() {
		this.popupTraining = new ModalWindow(null, <TrainingList  onSelect={(id) => this.handleSelectTraining(id)} />);
		this.popupTraining.className = 'wide950';
		this.popupTraining.show(this.context.store.dispatch);
	}

	handleSelectTraining(id) {
		this.popupTraining.hide();
		const client = new Client();
		client.call('training.fetch', {id}).then((data) => {
			data.form.drivers.forEach((item) => {
				this.handleAddDriver({
					id: item.driver,
					name:item.name,
					surname:item.surname,
					born:item.born,
					op: item.groups
				});
			});
		});
	}

	handleAddDriver(driver) {
		let drivers = this.form.getValues().get('drivers');
		if (!drivers) {
			drivers = immutable.List();
		}
		drivers = drivers.push({
			id: -Math.random(),
			driver: driver.id,
			name: driver.name,
			surname: driver.surname,
			born: driver.born,
			groups: driver.op.join(' ')
		});
		this.form.setValue({drivers: drivers.toJS()});
	}

	render() {

		const canEdit = true;
		const saveButton = <SaveButton
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const btns = <ButtonToolbar>
			{saveButton}
			{this.props.id > 0 && <ActionButton disabled={!canEdit} bsStyle="danger" icon="fa fa-trash-o" onClick={()=>this.remove()}>
				Odstranit
			</ActionButton>}
		</ButtonToolbar>;

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Dokument" buttons={btns} />
					<div className="row">
						<div className="col-md-6">
							<table className="form">
								<tbody>
									<FormRow name="title" labelWidth={140} />
									<FormRow name="folder" />
									<tr>
										<th>Skupiny I.</th>
										<td>
											<FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/> <FormField name="op_d"/> <FormField name="op_e"/> <FormField name="op_f"/> <FormField name="op_g"/> 											<FormField name="op_w1"/> <FormField name="op_w2"/> <FormField name="op_m"/> <FormField name="op_z"/>
										</td>
									</tr>
									<tr>
										<th>Skupiny II.</th>
										<td>
											<FormField name="op_a_2"/> <FormField name="op_b_2"/> <FormField name="op_c_2"/> <FormField name="op_d_2"/> <FormField name="op_e_2"/> <FormField name="op_f_2"/> <FormField name="op_g_2"/> 											<FormField name="op_w1_2"/> <FormField name="op_w2_2"/> <FormField name="op_m_2"/> <FormField name="op_z_2"/>
										</td>
									</tr>
									<FormRow name="type" />
									<FormRow name="yt_video" visible={this.schema.yt_video.visible} />
									<FormRow name="files" visible={this.schema.files.visible} />
									<FormRow className="buttons">
										{saveButton}
									</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Document/Form.js